
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "YOU MAY LIKE",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
};
